import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

// RxJS
import { catchError, map, Observable, of, take } from 'rxjs';

// Services
import { NetworkService } from '@modules/core/services/network.service';

/**
 * Redirects legacy `/records/:id` links — saved before project ids were part of the URL — to
 * `/{projectId}/records/{id}`, resolving the owning project from the record itself.
 */
@Injectable({
  providedIn: 'root'
})
export class RecordRedirectGuard implements CanActivate {

  /**
   * Constructor
   */

  constructor(
    private networkService: NetworkService,
    private router: Router,
  ) {}

  /**
   * Methods
   */

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> {
    const id = route.paramMap.get('id');
    if (!id) { return of(this.router.createUrlTree(['/'])); }
    // NetworkService, not RecordsService.getRecord() — the latter merges an interval and never
    // completes, which would hang the route.
    return this.networkService.getRecord(id)
      .pipe(
        take(1),
        map(record => record?.projectId
          ? this.router.createUrlTree(['/', record.projectId, 'records', id])
          : this.router.createUrlTree(['/'])),
        // Unknown or inaccessible record — fall through to the default project.
        catchError(() => of(this.router.createUrlTree(['/'])))
      );
  }

}
